import * as z from "zod";

export const unmergeFulfillmentOrdersFromGroups = {
  name: "unmergeFulfillmentOrdersFromGroups" as const,
  input: z.object({
    unmergeRequests: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        fulfillmentOrderIdsToUnmerge: z.array(z.string()),
      }),
    ),
  }),
  output: z.void(),
};
